import PropTypes from 'prop-types';
import { Modal, ModalBody } from 'reactstrap';
import clsx from 'clsx';

import './Screen.scss';

export const ModalScreen = ({
	backdrop,
	bodyClassName,
	children,
	className,
	contentClassName,
	header,
	id,
	isOpen,
	onClose,
	size,
}) => (
	<>
		<Modal
			backdrop={backdrop}
			centered
			className={className}
			contentClassName={clsx(
				'border-0 shadow-lg rounded overflow-hidden align-self-start bg-dark content-dark',
				contentClassName,
			)}
			id={id}
			isOpen={isOpen}
			size={size}
			toggle={onClose}
			zIndex={2000}
		>
			{header}
			<ModalBody className={bodyClassName}>
				{children}
			</ModalBody>
		</Modal>
		{!backdrop && (
			<div style={{ zIndex: 1900 }} className="backdrop-disabled modal-backdrop fade show" />
		)}
	</>
);

ModalScreen.propTypes = {
	backdrop: PropTypes.bool,
	bodyClassName: PropTypes.string,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	contentClassName: PropTypes.string,
	header: PropTypes.node,
	id: PropTypes.string,
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	size: PropTypes.string,
};

ModalScreen.defaultProps = {
	backdrop: true,
	bodyClassName: '',
	className: '',
	contentClassName: '',
	header: undefined,
	id: undefined,
	size: 'xl',
};
